<template>
  <div class="notree-boxbgcolor config">
    <ListPageLayout :loading="tableLoading">
    <template #filter>
        <div class="searchbox">
              <form action="#" method="get" class="form-inline form-float">
                <div class="form-group"></div>

                <div class="form-group others">
                  <!-- <span class="search_btn">
                    <button
                      @click="searchList"
                      type="button"
                      class="btn btn-primary"
                      id="search_btn" :disabled="tableLoading">{{ tableLoading ? "查询中..." : "查询" }}</button>
                  </span> -->

                  <span class="add_btn">
                    <button
                      type="button"
                      class="btn btn-default"
                      id="add"
                      @click="addOrEdit()"
                    >
                      添加
                    </button>
                  </span>
                </div>
              </form>
            </div>
    </template>

      <el-table
              ref="table"
              border
              :data="tableListData"
              height="100%"
              :header-cell-style="tableHeaderStyle"
              :cell-style="styleObj"
            >
              <el-table-column
                show-overflow-tooltip
                label="规则名称"
                prop="ruleName"
              ></el-table-column>
              <el-table-column show-overflow-tooltip label="平台审核" prop="userId">
                <template slot-scope="scope">
                  {{ convertToUserLabel(scope.row.userId) }}
                </template>
              </el-table-column>
              <el-table-column
                show-overflow-tooltip
                label="验证类型"
                prop="validateTypeText"
              >
              </el-table-column>
              <el-table-column
                show-overflow-tooltip
                label="密码/手机号码"
                prop="validateValue"
              >
                <template slot-scope="scope">
                  {{
                    scope.row.validateType == 2
                      ? "**********"
                      : scope.row.validateValue
                  }}
                </template>
              </el-table-column>
              <el-table-column show-overflow-tooltip label="提现类型" prop="type">
                <template slot-scope="scope">
                  {{ handleType(scope.row) }}
                </template>
              </el-table-column>
              <el-table-column
                show-overflow-tooltip
                label="固定金额或每月固定的某一天"
                prop="value"
              ></el-table-column>

              <el-table-column show-overflow-tooltip label="是否启用">
                <template slot-scope="scope">
                  <el-switch
                    :value="scope.row.enabled == 1 ? true : false"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    @change="(e) => handleSwitchChange(e, scope.row)"
                  >
                  </el-switch>
                </template>
              </el-table-column>
              <el-table-column
                show-overflow-tooltip
                label="创建时间"
                prop="crtTime"
              ></el-table-column>

              <el-table-column show-overflow-tooltip label="操作">
                <template slot-scope="scope">
                  <button
                    class="edit operate-button"
                    type="button"
                    @click="addOrEdit(scope.row)"
                  >
                    修改
                  </button>
                  <button
                    class="edit operate-button"
                    type="button"
                    @click="onSetUserBtn(scope.row)"
                  >
                    提现用户
                  </button>
                  <!-- <button
                      class="delete operate-button"
                      type="button"
                      @click="del(scope.row.id)"
                    >
                      删除
                    </button> -->
                </template>
              </el-table-column>
            </el-table>

      <template #pagination>
        <Page v-on:pagination="receivePaginationData"></Page>
      </template>
    </ListPageLayout>
    <!-- 添加/修改 -->
        <el-dialog
          :lock-scroll="false"
          :close-on-click-modal="false"
          title="添加/修改提现配置"
          :visible.sync="dialogFormVisible"
          width="700px"
          @close="closeFormDialog"
          class="dialog-form"
        >
          <div class="clearfix">
            <el-form
              @submit.native.prevent
              class="fl"
              style="width:100%;"
              ref="form"
              label-position="right"
              :model="form"
              :label-width="formLabelWidth"
              id="form"
            >
              <el-form-item label="规则名称" prop="ruleName">
                <el-col :span="18">
                  <el-input v-model="form.ruleName"></el-input>
                </el-col>
              </el-form-item>

              <el-form-item label="平台审批用户" prop="userId">
                <el-col :span="18">
                  <el-cascader
                    style="width: 100%; margin-top: -5px;"
                    v-model="form.userId"
                    :options="userOps"
                    @change="handleUserOpsChange"
                  ></el-cascader>
                </el-col>
              </el-form-item>
              <el-form-item label="验证类型" prop="ruleName">
                <el-col :span="18">
                  <el-select
                    v-model="form.validateType"
                    style="width: 100%; margin-top: 2px;"
                    @change="handleValidateTypeChange"
                  >
                    <el-option label="验证码" :value="1"></el-option>
                    <el-option label="密码" :value="2"></el-option>
                  </el-select>
                </el-col>
              </el-form-item>
              <template v-if="form.validateType">
                <template v-if="form.validateType == 1">
                  <el-form-item label="手机号码" prop="ruleName">
                    <div style="width: 100%; height: 100%; padding-top: 15px;">
                      {{
                        currentUserOps.mobile
                          ? currentUserOps.mobile
                          : "请先选择平台用户或先为用户绑定手机号码"
                      }}
                    </div>
                  </el-form-item>
                  <el-form-item
                    label="验证码"
                    prop="ruleName"
                    v-if="
                      currentUpdateUser == undefined ||
                        currentUpdateUser.validateValue !== form.validateValue
                    "
                  >
                    <el-col :span="12">
                      <el-input
                        v-model="form.code"
                        placeholder="请输入验证码"
                        :maxlength="5"
                        :disabled="isDisabled()"
                        @input="$forceUpdate()"
                      ></el-input>
                    </el-col>

                    <el-col :span="4" :offset="1">
                      <el-button
                        size="mini"
                        style="margin-top: -3px;"
                        :disabled="isDisabled() || leftSecond >= 0"
                        @click="handleCodeSend"
                        >{{
                          leftSecond >= 0 ? `重发(${leftSecond})` : "发送验证码"
                        }}</el-button
                      >
                    </el-col>
                  </el-form-item>
                </template>
                <el-form-item label="密码" v-else>
                  <el-col :span="18">
                    <el-input
                      type="password"
                      v-model="form.validateValue"
                      @input="$forceUpdate()"
                      placeholder="请输入操作密码"
                    ></el-input>
                  </el-col>
                </el-form-item>
              </template>

              <el-form-item label="提现类型" prop="type">
                <el-col :span="18">
                  <el-select v-model="form.type">
                    <el-option label="固定金额" value="1"></el-option>
                    <el-option label="每月固定的某一天" value="2"></el-option>
                  </el-select>
                </el-col>
              </el-form-item>
              <el-form-item
                :label="form.type == 1 ? '金额' : '日期'"
                prop="address"
              >
                <div style="display: flex;align-items: center;">
                  <el-col :span="16">
                    <el-input v-model="form.value"></el-input>
                  </el-col>
                  <span>{{ form.type == 1 ? "(元)" : "日" }}</span>
                </div>
              </el-form-item>
            </el-form>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="addOrEditTrue">确 定</el-button>
            <el-button @click="dialogFormVisible = false">取 消</el-button>
          </div>
        </el-dialog>
  </div>
</template>
<script>
import {
  withdrawRule,
  shareUserInfo,
  updateShareProfitConfig,
  updateWithdrawRuleStatus,
  groupUserOps,
  sendWithdrawCode,
} from "@/api/url";
import { TYPE, VALIDATE_TYPE } from "./constant";
import { mapState, mapMutations } from "vuex";
import Page from "@/page/commons/page";
import ListPageLayout from '@/page/commons/ListPageLayout.vue';
export default {
  data() {
    return {
      styleObj: {
        "text-align": "center",
      },
      tableHeaderStyle: {
        "text-align": "center",
        background: "#F9F9FB",
      },

      form: {
        ruleName: "",
        type: "1",
        value: "",
        enabled: 1,
        userId: undefined,
        validateType: undefined,
        validateValue: undefined,
        code: undefined,
      },
      configureForm: {
        groupId: "",
        code: [],
      },
      search: {
        pageNumber: 1,
        pageSize: 10,
        sharedId: [],
      },
      tableLoading: false,
      tableListData: [],
      tableListDataTitle: [],
      groupBaseConfigureData: [],
      groupConfigureData: [], //用户配置数据
      tableListDataExcel: {},
      formLabelWidth: "180px",
      dialogFormVisible: false,
      dialogFormHeartTimeVisible: false,
      dialogConfigureVisible: false, //配置
      userOps: [],
      currentUserOps: {},
      currentUpdateUser: undefined,
      parks: [],
      shareUser: {},
      leftSecond: -1,
    };
  },
  components: {
    ListPageLayout,
    Page,
  },
  methods: {
    ...mapMutations(["getPage"]),
    receivePaginationData(v1, v2) {
      this.search.pageNumber = v1;
      this.search.pageSize = v2;
      this.tableList(this.search.pageNumber);
    },
    tableList: function(curPage) {
      var _this = this;
      _this.tableLoading = true;
      this.$get(`${withdrawRule()}`, {
        page: curPage,
        limit: this.search.pageSize,
      })
        .then((data) => {
          if (data.status != 200) return _this.$layer.msg(data.message);
          var pageObj = {
            curIndex: data.data.offset,
            rowsCount: data.data.total,
          };
          _this.getPage(pageObj);
          _this.tableListData = (data?.data?.rows ?? []).map((item) => {
            return item;
          });
        })
        .finally(() => (_this.tableLoading = false));
    },
    openDialog: function() {},
    closeFormDialog: function() {
      // this.$refs["form"].resetFields();
      this.currentUpdateUser = undefined;
      this.currentUserOps = {};
    },
    searchList: function() {
      if (this.tableLoading) return;
      this.tableList();
    },
    clearSearch: function() {
      if (this.tableLoading) return;
      this.search.pageNumber = 1;
      this.tableList();
    },
    addOrEdit: function(row) {
      this.dialogFormVisible = true;
      this.form = {
        ruleName: "",
        type: "",
        value: "",
        enabled: 1,
      };
      if (Boolean(row?.id)) {
        this.form = {
          ...row,
          type: row.type + "",
        };
        this.currentUpdateUser = { ...this.form };
        if (this.currentUpdateUser.validateType == 1)
          this.currentUserOps.mobile = this.currentUpdateUser.validateValue;
      }
    },
    addOrEditTrue: function() {
      var _this = this;
      this.$refs["form"].validate(function(valid, noStri) {
        if (valid) {
          if (!Boolean(_this.form?.id)) {
            _this
              .$postRequest(withdrawRule(), {
                ..._this.form,
              })
              .then((data) => {
                if (data?.status != 200)
                  return _this.$message.success(data.message);
                _this.$notify({
                  type: "success",
                  message: "添加成功",
                  title: "成功",
                });
                _this.search.pageNumber = 1;
                _this.tableList(1);
                _this.dialogFormVisible = false;
              });
          } else {
            _this
              .$putRequest(withdrawRule(), {
                ..._this.form,
              })
              .then((data) => {
                if (data?.status != 200)
                  return _this.$message.success(data.message);
                _this.$notify({
                  type: "success",
                  message: "修改成功",
                  title: "成功",
                });
                _this.tableList(_this.curIndex);
                _this.dialogFormVisible = false;
              });
          }
        }
      });
    },
    handleUserOpsChange(val) {
      if (!val) return;

      if (val.length != 2) this.form.userId = undefined;
      else {
        this.form.userId = val[1];
        for (const userOps of this.userOps) {
          for (const user of userOps.children) {
            if (user.value === this.form.userId) {
              this.currentUserOps = user;
              this.form.validateValue = user.mobile;
              return;
            }
          }
        }
      }
    },
    handleValidateTypeChange: function(val) {
      this.form.validateValue = this.currentUserOps.mobile;
      this.form.code = undefined;
      if (val == 2) this.form.validateValue = undefined;
      this.$forceUpdate();
    },
    getShareUserInfo(mobile) {
      this.$get(shareUserInfo(), { mobile }).then((res) => {
        if (res?.status !== 200) {
          this.$message.error(res?.message || '获取用户信息失败');
          return;
        }
        this.form.userId = res?.data?.[0]?.value ?? "";
        this.form.openId = res?.data?.[0]?.openId ?? "";
      }).catch((error) => {
        console.error(error);
      });
    },
    onUserInfoSearch() {
      this.getShareUserInfo(this.form.mobile);
    },
    handleType(row) {
      return TYPE[row.type];
    },

    handleSwitchChange(e, row) {
      this.$postRequest(updateWithdrawRuleStatus(), {
        ruleId: row.id,
        enabled: e ? 1 : 2,
      }).then((res) => {
        if (res.status != 200) return this.$message.error(res.message);
        this.$message.success("设置成功");
        this.tableList(this.curIndex);
      });
    },
    handleRemove() {},
    handlePictureCardPreview() {},
    onSetUserBtn(row) {
      console.log("999");
      this.$router.push({
        path: "/main/split-accounting/config/withdrawal-user",
        query: {
          id: row?.id ?? "",
        },
      });
    },
    isDisabled: function() {
      if (this.form.validateType != undefined && this.form.validateType == 1) {
        return (
          this.form.validateValue == undefined ||
          this.form.validateValue.length == 0
        );
      }

      return true;
    },
    convertToUserLabel: function(userId) {
      let targetLabel = "-";
      this.userOps.forEach((f) => {
        f.children.forEach((fc) => {
          if (fc.value == userId) {
            targetLabel = `${f.label}/${fc.label}`;
            return;
          }
        });
      });
      return targetLabel;
    },
    async getUserOps() {
      const data = await this.$get(groupUserOps());
      if (data.status == 200) this.userOps = data.data;
    },
    async handleCodeSend() {
      if (this.form.validateType !== 1) {
        this.$message({ type: "error", message: "请先选择验证码认证方式" });
        return;
      }
      if (
        this.form.validateValue == undefined ||
        this.form.validateValue.length == 0
      ) {
        this.$message({ type: "error", message: "手机号码异常" });
        return;
      }

      // 发送验证码
      const data = await this.$postRequest(sendWithdrawCode(), {
        mobile: this.form.validateValue,
        type: 1,
      });
      if (data.data === true) {
        this.leftSecond = 60;
        const timer = setInterval(() => {
          if (this.leftSecond < 0) {
            clearInterval(timer);
            return;
          }

          this.leftSecond -= 1;
        }, 1000);
        this.$message({ type: "success", message: "短信验证码发送成功" });
      }
    },
  },
  computed: {
    ...mapState({
      curIndex: (state) => state.page.curIndex,
      rowsCount: (state) => state.page.rowsCount,
    }),
  },
  created: function() {},
  mounted: async function() {
    await this.getUserOps();
    this.search.pageNumber = 1;
    this.tableList(1);
  },
  destroyed: function() {},
};
</script>

<style scoped>
.table-rule {
  color: #222;
  border-spacing: 0;
  border-collapse: collapse;
}
.table-rule tr td {
  padding: 10px 10px;
  text-align: center;
  border: 1px solid #ccc;
  font-size: 14px;
}

.table-rule .money-input,
.table-rule .time-input {
  width: 40px;
  height: 26px;
  border: 1px solid #ccc;
  /* border: 1px solid #02c1af; */
  border-radius: 2px;
  text-align: center;
  color: #222;
  color: #02c1af;
}

.searchbox {
  background: #f9f9fb;

  border-bottom: 10px solid #eff2f7;
}
.table thead {
  background: #f9f9fb;
}
.list {
  width: 100% !important;
  position: relative;
}
.pagbox {
  position: absolute;
  bottom: 5px;
  right: 5px;
}
/* .edit,
    .delete,
    .chargingRules {
      display: inline-block;
      width: 40px;
      height: 20px;
      background: #278cd8;
      color: white;
      margin-right: 4px;
      font-size: 12px;
      line-height: 20px;
      border-radius: 4px;
    } */
.chargingRules {
  width: 60px;
}
.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.fail,
.success,
.someSuccess {
  display: inline-block;
  border-radius: 4px;
  width: 12px;
  height: 12px;
}
.fail {
  background: red;
  color: red;
}
.success {
  background: green;
  color: green;
}
.someSuccess {
  background: #ff6100;
  width: 65px;
  height: 20px;
  line-height: 20px;
  color: white;
  font-size: 12px;
}
.lowerEquip {
  width: 60px;
  font-size: 12px;
  background: #409eff;
  color: white;
  height: 20px;
  line-height: 20px;
}
.refresh {
  display: inline-block !important;
}
.pow {
  text-align: left !important;
  padding-left: 1% !important;
}
.show_pow {
  border: 1px solid #696969;
  border-radius: 2px;
}
.pow_head {
  margin-left: -5%;
  border-radius: 1px;
}
.configure-message {
  margin-right: 20px;
}
</style>
<style>
.config .el-form-item {
  margin: 0;
}
.config .dialog-form .el-divider {
  margin: 0;
  margin-bottom: 10px;
}
.config .dialog-form .el-select {
  width: 100%;
}
.config .el-popper.el-cascader__dropdown {
  z-index: 20000 !important;
}
.config .el-cascader {
  position: relative;
}
</style>
